import * as React from 'react';
import styled from 'styled-components/macro';
import { Modal } from 'lib/components';
import { Button } from 'react-covideo-common';
import selectors from '../../../../../../../../cypress/selectors';
import { IoMdClose } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

const ModalItem = styled.div`
  box-sizing: border-box;
  width: 592px;
  padding: 32px;
  background-color: ${({ theme }) => theme.colors.white[100]};
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const Title = styled.div`
  color: ${({ theme }) => theme.colors.black[100]};
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
`;
const Content = styled.div`
  margin-top: 32px;
`;
const CloseButtonWrapper = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.neutral[40]};
  &:hover {
    cursor: pointer;
  }
`;
const ButtonsWrapper = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  gap: 16px;
`;

type Props = {
  handleModalClose: () => void;
  handleSubmit: () => void;
};
export const ModalNoQuotePrompt = ({
  handleModalClose,
  handleSubmit,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Modal>
      <ModalItem>
        <Header>
          <Title>{t('Send Without Quote?')}</Title>
          <CloseButtonWrapper>
            <IoMdClose size={24} onClick={handleModalClose} />
          </CloseButtonWrapper>
        </Header>
        <Content>
          {t(
            'Are you sure you want to send a video with an RO number but without a quote?'
          )}
        </Content>
        <ButtonsWrapper>
          <Button
            text={t('No, Add Quote')}
            onClick={() => handleModalClose()}
            variant='secondary'
          />
          <Button
            text={t('Yes, Send Without Quote')}
            variant='primary'
            onClick={() => handleSubmit()}
            data-cy={selectors.libraryPage.sendAndShareModal.sendWithoutQuote}
          />
        </ButtonsWrapper>
      </ModalItem>
    </Modal>
  );
};
